import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import EcoLink from 'eco-design/base/eco-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import { getIsPadWidth } from '@elem/utils/devices';
import { useRouter } from 'next/router';

export default function Comp() {
    const { t } = useLang('powerBank.F');
    const { locale = 'us' } = useRouter();
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_US = ['us', 'ca'].includes(locale);
    const dataA: EcoBannerProps = {
        layout: 'center-left',
        pc:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506711577/Frame%201612707669.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1747908980502/Frame%201612707497.jpg',
        pad: locale === 'ph' ? 'https://websiteoss.ecoflow.com/upload/image/1762506711577/Frame%201612707669.jpg' : '',
        h5:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506644573/Frame%201612707673.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1748773306356/Frame%201612707439%20(1).jpg',
        label: t('label_1'),
        title: t('title_1'),
        desc: t('desc_1'),
        theme: 'white',
        className: 'banner-card-a',
    };
    const dataB: EcoBannerProps = {
        layout: 'center-right',
        pc:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762506643549/Frame%201612707670.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1753259272144/Frame%201612707499.jpg',
        pad: locale === 'ph' ? 'https://websiteoss.ecoflow.com/upload/image/1762506643549/Frame%201612707670.jpg' : '',
        h5:
            locale === 'ph'
                ? 'https://websiteoss.ecoflow.com/upload/image/1762744634405/m%20new%2001.jpg'
                : 'https://websiteoss.ecoflow.com/upload/image/1753259273602/Frame%201612707560.jpg',
        label: t('label_2'),
        title: t('title_2'),
        desc: t('desc_2'),
        theme: 'white',
        className: 'banner-card-b',
    };
    const isMobile = getIsPadWidth();

    const [load, setLoad] = useState(true);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const secneF = AniContainer.create({
                triggerElement: '.Rapid-E',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                secneF.destroy();
            };
        }
    }, []);
    useEffect(() => {
        const container = '.temp-section-1';
        let scrollHeight = !isMobile ? innerHeight - 46 : innerHeight - 14;
        let duration = '140%';
        if (locale === 'jp') {
            duration = window.innerWidth < 768 ? '250%' : '180%';
        } else if (IS_EU) {
            duration = '180%';
        } else if (IS_US) {
            duration = window.innerWidth < 768 ? '250%' : '200%';
        }
        load &&
            AniContainer.create({
                asyncFromTo: [
                    ['.temp-section-1 .banner-card-b', { top: scrollHeight }, { top: 0 }, 0.001], //
                ],
                asyncTimeLine: [0.001],
                triggerElement: container,
                triggerHook: 0,
                offset: '0%',
                duration: duration,
            });
    }, [load]);

    return (
        <div className={`temp-section-1 ${styles.comp} Rapid-F GtmModuleData-section`} data-section-id="Rapid-F" id="section-1">
            <div className="sticky">
                {<EcoBanner {...dataA} />}
                {<EcoBanner {...dataB} />}
            </div>
        </div>
    );
}
